export const USER_DETAILS = 'userDetails';
export const TRIPS_LIST = 'tripsList';
export const ARTICLES_LIST = 'articlesList'
export const SET_LOCATION = 'locationByArticle'
export const SET_LANGUAGE = 'currentLang'
export const SET_LOCATION_BOOK = 'locationByBook'
export const SEARCH_TRIP =  'searchTrip'
export const SEARCH_ARTICLE = 'searchArticle'
export const ARTICLES_LIST_TRIP = 'articlesList_Trip'
export const CURRENT_TRIP_ID = 'currentTripId'